import { Link, NavLink } from "react-router-dom";
import { UserButton } from "@clerk/react";
import { Plane, LayoutDashboard, Mic, ShieldCheck, ListChecks, Users, Settings, History } from "lucide-react";
import { useMe } from "@/lib/api";

const userLinks = [
  { to: "/dashboard", label: "My History", icon: History, id: "nav-dashboard" },
  { to: "/interview/new", label: "New Assessment", icon: Mic, id: "nav-new-assessment" },
];
const adminLinks = [
  { to: "/admin", label: "Overview", icon: LayoutDashboard, id: "nav-admin-overview", end: true },
  { to: "/admin/sessions", label: "Responses", icon: ListChecks, id: "nav-admin-sessions" },
  { to: "/admin/questions", label: "Question Bank", icon: ShieldCheck, id: "nav-admin-questions" },
  { to: "/admin/users", label: "Users", icon: Users, id: "nav-admin-users" },
  { to: "/admin/settings", label: "Officer Settings", icon: Settings, id: "nav-admin-settings" },
];

const NavItem = ({ to, label, icon: Icon, id, end }) => (
  <NavLink to={to} end={end} data-testid={id} title={label}
    className={({ isActive }) => `flex items-center gap-2 px-3 py-2 text-sm transition-colors ${isActive ? "bg-blue-600 text-white" : "text-slate-400 hover:text-white hover:bg-slate-800"}`}>
    <Icon className="w-4 h-4 shrink-0" /> <span className="whitespace-nowrap hidden xl:inline">{label}</span>
  </NavLink>
);

export default function AppShell({ children }) {
  const { me } = useMe();
  const isAdmin = me?.role === "admin";
  return (
    <div className="min-h-screen bg-slate-950 relative z-10">
      <header className="sticky top-0 z-40 bg-slate-950/80 backdrop-blur-xl border-b border-slate-800">
        <div className="flex items-center gap-6 px-6 lg:px-10 h-16">
          <Link to="/dashboard" className="flex items-center gap-2 text-white font-cabinet font-extrabold text-lg shrink-0" data-testid="header-logo">
            <Plane className="w-5 h-5 text-blue-500" /> <span className="hidden sm:inline">E-immigration</span>
          </Link>
          <nav className="flex items-center gap-1 overflow-x-auto flex-1">
            {userLinks.map((l) => <NavItem key={l.to} {...l} />)}
            {isAdmin && <span className="mx-2 h-5 w-px bg-slate-800" />}
            {isAdmin && adminLinks.map((l) => <NavItem key={l.to} {...l} />)}
          </nav>
          <div className="flex items-center gap-3 shrink-0">
            {isAdmin && <span className="hidden md:inline font-mono text-[10px] tracking-[0.2em] text-amber-500 border border-amber-500/40 px-2 py-1" data-testid="super-admin-badge">SUPER ADMIN</span>}
            <span className="hidden md:inline text-sm text-slate-400" data-testid="header-user-name">{me?.name}</span>
            <UserButton />
          </div>
        </div>
      </header>
      <main className="px-6 lg:px-10 py-10 w-full max-w-[1400px] mx-auto">{children}</main>
    </div>
  );
}
